import { ChangeDetectionStrategy, Component, computed, HostListener, input, OnInit } from '@angular/core';
import { ITagGroup } from '@shared/constants/models.const';
import { E_NEWS_TAGS_COLORS } from '@shared/constants/enums.const';
import { TextOverflowDirective } from '@shared/directives/text-overflow.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-color-tag',
  imports: [
    TextOverflowDirective,
    MatTooltip,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './color-tag.component.html',
  styleUrl: './color-tag.component.scss',
})
export class ColorTagComponent implements OnInit {
  withBMargin = input(true);
  tag = input<ITagGroup>();
  tagTitle = input<string>();
  tagColor = input<E_NEWS_TAGS_COLORS>(E_NEWS_TAGS_COLORS.White);
  isLast = input<boolean>(false);
  finalClassName = '';

  title = computed(() => {
    // implementing singular for other languages

    if (this.tagTitle()?.toLowerCase() === 'news') {
      return 'News_1';
    } else {
      return this.tagTitle();
    }
  });
  maxWidth = 250;

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.setMaxWidth();
  }

  setMaxWidth(): void {
    const mainSection: HTMLElement | null = document.querySelector('.main-section');
    if (mainSection) {
      this.maxWidth = mainSection?.offsetWidth - 15;
    }
  }

  ngOnInit(): void {
    if (this.tag()) {
      this.setColorByTag();
    } else {
      this.finalClassName = `is-${this.tagColor()}`;
    }
    this.setMaxWidth();
  }

  setColorByTag(): void {
    switch (this.tag()?.color) {
      case E_NEWS_TAGS_COLORS.Blue:
        this.finalClassName = `is-${E_NEWS_TAGS_COLORS.Blue}`;
        break;
      case E_NEWS_TAGS_COLORS.None:
      case E_NEWS_TAGS_COLORS.Grey:
        this.finalClassName = `is-${E_NEWS_TAGS_COLORS.Grey}`;
        break;
      case E_NEWS_TAGS_COLORS.Green:
        this.finalClassName = `is-${E_NEWS_TAGS_COLORS.Green}`;
        break;
      case E_NEWS_TAGS_COLORS.White:
        this.finalClassName = `is-${E_NEWS_TAGS_COLORS.White}`;
        break;
    }
  }
}
